/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free text repeater. Repeat any text a set number of times with your choice of separator and optional numbering. Runs in your browser.`)
};

const es_tr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetidor de texto gratuito. Repite cualquier texto un número elegido de veces con tu separador preferido y numeración opcional. Se ejecuta en tu navegador.`)
};

const de_tr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Textwiederholer. Wiederholen Sie beliebigen Text eine festgelegte Anzahl von Malen mit Ihrem gewählten Trennzeichen und optionaler Nummerierung. Läuft direkt in Ihrem Browser.`)
};

const nl_tr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis tekstherhaler. Herhaal elk woord, regel of tekstblok een ingesteld aantal keer met je keuze van scheidingsteken en optioneel nummerering. Werkt in je browser.`)
};

const fr_tr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répéteur de texte gratuit. Répétez n'importe quel texte un nombre défini de fois avec votre choix de séparateur et numérotation optionnelle. Fonctionne dans votre navigateur.`)
};

const it_tr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripetitore di testo gratuito. Ripeti qualsiasi testo un numero impostato di volte con la scelta del separatore e numerazione opzionale. Funziona nel tuo browser.`)
};

const pt_br2_tr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetidor de texto gratuito. Repita qualquer texto um número definido de vezes com sua escolha de separador e numeração opcional. Funciona no seu navegador.`)
};

const pt_tr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetidor de texto gratuito. Repita qualquer texto um número definido de vezes com o seu separador à escolha e numeração opcional. Funciona no seu navegador.`)
};

const ja_tr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のテキストリピーター。任意のテキストを指定回数繰り返し、セパレーターと任意の番号付けを選択できます。ブラウザで実行されます。`)
};

const zh_tr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费文本重复器。按设定次数重复任意文本，可选择分隔符和编号。完全在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tr_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tr_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tr_tool_description", locale)
	if (locale === "en") return en_tr_tool_description(inputs)
	if (locale === "es") return es_tr_tool_description(inputs)
	if (locale === "de") return de_tr_tool_description(inputs)
	if (locale === "nl") return nl_tr_tool_description(inputs)
	if (locale === "fr") return fr_tr_tool_description(inputs)
	if (locale === "it") return it_tr_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_tr_tool_description(inputs)
	if (locale === "pt") return pt_tr_tool_description(inputs)
	if (locale === "ja") return ja_tr_tool_description(inputs)
	return zh_tr_tool_description(inputs)
};